import React from 'react';
import CareMapprPopup from '../../Popup/CareMapprPopup';
import {
  //Speedometer2,
  //Stopwatch,
  ThreeDotsVertical,
} from 'react-bootstrap-icons';
//import Chip from '../../Chip/Chip';
//import { ChipBackgroundColor, ChipLabelColor } from '../../Chip/types';
//import EventTriggers from '../components/EventTriggers';
//import ProbabilityScoreTriggers from '../components/ProbabilityScoreTriggers';
import './style.css';
import QuestionsSidebar from '../../../pages/DataAnnotation/components/QuestionsSidebar';
import DataAnnotationProvider from '../../../pages/DataAnnotation/context/DataAnnotationProvider';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
interface SurveyPopupProps {
  open: boolean;
  onHide: () => void;
}
const SurveyPopup = ({ onHide, open }: SurveyPopupProps) => {
  const { patientProfile } = useSelector(
    (state: RootState) => state.patientProfile,
  );

  const clientNumber = patientProfile.clinics?.[0]?.client_no || '';
  const patientName = `${patientProfile.first_name} ${patientProfile.middle_name || ''} ${patientProfile.last_name}`;
  return (
    <CareMapprPopup
      show={open}
      onHide={() => onHide()}
      // TODO in AM-358
      //title="Additional insights and feedback"
      title="Feedback"
      titleIcon={<ThreeDotsVertical size={18} />}
    >
      <div className="body-container">
        <span className="subtitle">{`${patientName}${clientNumber ? ` - ${clientNumber}` : ''}`}</span>
        {/* 
        TODO in AM-358
        <div className="section">
          <p className="section-body">
            <div className="d-flex justify-content-between">
              <div className="d-flex gap-2">
                <span>Urgency:</span>
                <Chip labelText="Today" icon={<Stopwatch size={12} />} />
              </div>
              <div className="d-flex gap-2">
                <span>Effort:</span>
                <Chip
                  labelText="Medium"
                  icon={<Speedometer2 size={12} />}
                  backgroundColor={ChipBackgroundColor.YELLOW}
                  labelColor={ChipLabelColor.YELLOW}
                />
              </div>
            </div>
          </p>
          <EventTriggers />
          <ProbabilityScoreTriggers />
        </div> */}
        <DataAnnotationProvider inPatientDetails>
          <QuestionsSidebar
            inPatientDetails
            isSideBar={true}
            onHidePopup={() => onHide()}
          />
        </DataAnnotationProvider>
      </div>
    </CareMapprPopup>
  );
};

export default SurveyPopup;
